import { STATUS_BADGE_CLASSES } from "./types";

const ADD_BUTTON_BASE = "rounded px-3 py-1.5 text-xs font-semibold uppercase tracking-wide flex items-center gap-1";

export const addButtonPt = (themedButtonClass: string) => ({
  root: {
    class: `${ADD_BUTTON_BASE} ${themedButtonClass}`,
  },
});

export const addButtonDisabledPt = {
  root: {
    class: `${ADD_BUTTON_BASE} bg-gray-475 text-gray-600 !opacity-100 cursor-not-allowed`,
  },
};

export const statusBadgePt = {
  root: { class: "rounded-full px-2.5 py-0.5 text-xs font-medium border-0" },
};

export const todoStatusDropdownPt = (status: string) => {
  const colors = STATUS_BADGE_CLASSES[status];
  const bgClass = colors?.bg ?? "bg-gray-100";
  const textClass = colors?.text ?? "text-gray-600";

  const outlineClass = colors?.outline ?? "outline-gray-600";

  return {
    root: {
      class: `inline-flex items-center rounded-full border-0 cursor-pointer ${bgClass} ${textClass} ${outlineClass} focus-within:outline focus-within:outline-2 focus-within:outline-offset-2`,
    },
    input: {
      class: `py-1 pl-3 pr-1 bg-transparent border-0 text-xs font-semibold whitespace-nowrap outline-none focus:shadow-none ${textClass}`,
    },
    trigger: {
      class: `w-5 shrink-0 bg-transparent ${textClass}`,
    },
    panel: {
      class: "min-w-60 bg-white border border-gray-175 rounded-lg shadow-[0_14px_34px_rgba(30,38,76,0.16)]",
    },
    wrapper: {
      class: "max-h-72 overflow-auto",
    },
    list: {
      class: "p-1.5 m-0 list-none",
    },
    item: ({
      context,
    }: {
      context: { focused: boolean; disabled: boolean; selected: boolean; option: { status: string } };
    }) => ({
      class: [
        "flex items-start w-full m-0 px-2.5 py-2 rounded-md border-0 text-left hover:bg-gray-125",
        context.disabled ? "cursor-not-allowed" : "cursor-pointer",
        { "bg-gray-125": context.selected || (context.disabled && context.option.status === status) },
        { "ring-1 ring-inset ring-indigo-base": context.focused },
      ],
    }),
  };
};
